import React, { useEffect } from 'react';
import BannerNoInstalacion from '../../layouts/BannerNoInstalacion';

const DireccionFormulario = () => {
  // Silenciar errores de ResizeObserver (funciona en todos los navegadores)
  useEffect(() => {
    const handleError = (e) => {
      if (e.message && e.message.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        return true;
      }
    };
    window.addEventListener('error', handleError);
    return () => window.removeEventListener('error', handleError);
  }, []);

  // Carga del formulario HubSpot
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    document.body.appendChild(script);

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '47654427',
          formId: '643ee4e5-37a4-46b6-b9b7-ac2202958633',
          target: '#hubspot-form',
        });
      }
    };
  }, []);

  return (
    <section id="contacto">
      <div className="container">
        <div className="row">
          {/* Columna izquierda: info + mapa */}
          <div className="col-lg-7 col-xl-6 mb-4 mb-lg-0 wow fadeIn" data-wow-delay="200ms">
            <div className="pe-lg-3">

              {/* Card Ubicación */}
              <div className="card card-style8 mt-1-9 wow fadeIn" data-wow-delay="200ms">
                <div className="card-body p-1-9">
                  <div className="media">
                    <div><i className="ti-location-pin text-white"></i></div>
                    <div className="media-body ms-3">
                      <h4 className="h5">Ubicación</h4>
                      <span>
                        Pte. 118 No. 333-A Col. Capultitlán, CDMX,<br />
                        C.P. 07370 Del. G.A.M. México
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card Teléfono */}
              <div className="card card-style8 mt-1-9 wow fadeIn" data-wow-delay="400ms">
                <div className="card-body p-1-9">
                  <div className="media">
                    <div><i className="ti-mobile text-white"></i></div>
                    <div className="media-body ms-3">
                      <h4 className="h5">Teléfono</h4>
                      <a href="tel:+525596273546">
                        <span className="d-block">55 96 27 35 46</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mapa con altura fija (sin dinámicas) */}
              <div className="mt-1-9 wow fadeIn" data-wow-delay="300ms">
                <div className="map-wrapper">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d737.2073828190188!2d-99.13545183950374!3d19.479217558947056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f9939aac79c9%3A0x366df159539bd580!2sDECOTOTAL!5e1!3m2!1ses!2smx!4v1775082731746!5m2!1ses!2smx"
                    className="map-iframe"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Ubicación DECOTOTAL"
                  />
                </div>
              </div>

              {/* Banner */}
              <div className="w-100 mt-1-9">
                <BannerNoInstalacion />
              </div>
            </div>
          </div>

          {/* Columna derecha: formulario */}
          <div className="col-lg-5 col-xl-6 wow fadeIn" data-wow-delay="400ms">
            <div className="contact-form p-4 p-md-5 ms-xl-3">
              <div className="title-style2 mb-2-2">
                <h2>Contáctanos Ahora</h2>
              </div>
              <form>
                <div id="hubspot-form"></div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Estilos CSS para el mapa (fuera del componente o dentro con <style> si prefieres) */}
      <style>
        {`
          .map-wrapper {
            position: relative;
            width: 100%;
            height: 350px;  /* altura fija en desktop */
            border-radius: 16px;
            overflow: hidden;
            box-shadow: 0 8px 24px rgba(0,0,0,0.12);
          }
          .map-iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
          }
          @media (max-width: 768px) {
            .map-wrapper {
              height: 250px;  /* altura menor en móviles */
            }
          }
        `}
      </style>
    </section>
  );
};

export default DireccionFormulario;